module.exports = __webpack_public_path__ + "img/cloudpay.ad4974f7.png";